import { ImageCTA } from "components";
import type { ReactStoryblokComponent } from "modules/storyblok/types";
import getUrlFromLink from "utils/getUrlFromLink";
import { ImageCTAVariantsMap } from "./ImageCTA.config";
import type { CTASAdapterProps } from "./ImageCTA.d";

const ImageCTASAdapter = ({
  blok: { heading, buttonText, buttonLink, imageUrl, gtmSection, gtmElement, variant = "option-1" },
}: ReactStoryblokComponent<CTASAdapterProps>) => {
  const resolvedButtonUrl = getUrlFromLink(buttonLink);

  return (
    <ImageCTA
      text={heading}
      buttonText={buttonText}
      buttonHref={resolvedButtonUrl}
      imageUrl={imageUrl || undefined}
      gtmSection={gtmSection}
      gtmElement={gtmElement}
      variant={ImageCTAVariantsMap[variant] || "basic"}
    />
  );
};

export default ImageCTASAdapter;
